// Router Reports
export default [
  // Pulse Report
  {
    path: '/pulse/report/leader',
    name: 'pulseReportLeader',
    component: () => import(/* webpackChunkName: "pulseReport" */ '../../views/reports/pulse/PulseReport.vue'),
  },
  {
    path: '/pulse/report/leader/:id',
    name: 'pulseReportCoach',
    component: () => import(/* webpackChunkName: "pulseReport" */ '../../views/reports/pulse/PulseReport.vue'),
  },

  // Invoice Report
  {
    path: '/invoice/report',
    name: 'invoiceReport',
    component: () => import(/* webpackChunkName: "invoiceReport" */ '../../views/reports/invoice/InvoiceReport.vue'),
    meta: {
      roles: ['leader'],
    },
  },
  {
    path: '/invoice/report/:id',
    name: 'invoiceReportAdmin',
    component: () => import(/* webpackChunkName: "invoiceReport" */ '../../views/reports/invoice/InvoiceReport.vue'),
    meta: {
      roles: ['MAM', 'OA', 'coach'],
    },
  },
  {
    path: '/invoice/detail/:id',
    name: 'invoiceDetail',
    component: () => import(/* webpackChunkName: "invoiceReport" */ '../../views/reports/invoice/InvoiceDetail.vue'),
    meta: {
      roles: ['MAM', 'OA', 'coach'],
    },
  },
];
